export const stringHasNumber = (str: string): boolean => /\d/.test(str);
export const capitalize = (str: string) =>
  `${str[0].toUpperCase()}${str.slice(1)}`;

export const numberToString = (val: number, decimals: number = 2) =>
  val.toLocaleString('de-DE', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  });
